import Vue from 'vue'
import axios from 'axios'
import store from '@/store'
import { VueAxios } from './axios'
import notification from 'ant-design-vue/es/notification'
import Modal from 'ant-design-vue/es/modal'
import { ACCESS_TOKEN } from '@/store/mutation-types'
import router from '@/router'
import { sysInfo } from '@/config'
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded'

// 创建 axios 实例
const service = axios.create({
  // baseURL: 'http://localhost:8000/data', // api base_url
  // baseURL: '', // api base_url
  // baseURL: '/api', // api base_url
  timeout: 60000 // 请求超时时间
})
const err = (error) => {
  console.log('error', error)
  if (error.response) {
    console.log('error_response', error.response)
    const data = error.response
    const token = Vue.ls.get(ACCESS_TOKEN)
    if (error.response.config.responseType === 'blob') {
      const reader = new FileReader()
      reader.readAsText(error.response.data, 'utf-8')
      reader.onload = function (e) {
        const result = JSON.parse(reader.result)
        notification.error({
          message: '操作异常',
          description: result.info.message
        })
      }
    } else {
      if (error.response.status === 403) {
        if (token) {
          Modal.confirm({
            iconType: 'exclamation-circle',
            title: data.data.info.message,
            content: '账号权限不足，是否重新登录？',
            onOk () {
              store.dispatch('Logout').then(() => {
                setTimeout(() => {
                  if (!sysInfo.ifDebug) {
                    location.href = sysInfo.loginURl
                  } else {
                    window.location.reload()
                  }
                }, 500)
              })
            },
            onCancel () {
            }
          })
        } else {
          notification.error({
            message: data.data.info.message,
            description: '请重新登录！'
          })
        }
      } else if (error.response.status === 401) {
        if (!error.response.data.status === 1006) {
          notification.error({
            message: data.data.info.message,
            description: '请重新登录！'
          })
        }
        store.dispatch('Logout').then(() => {
          setTimeout(() => {
            if (!sysInfo.ifDebug) {
              location.href = sysInfo.loginURl
            } else {
              window.location.reload()
            }
          }, 1500)
        })
      } else if (error.response.status === 408) {
        console.log('408', error.response)
        notification.error({
          message: data.data.info.message,
          description: '请求超时'
        })
      } else if (error.response.status === 1001) {
        if (!error.response.data.status === 1006) {
          notification.error({
            message: data.data.info.message,
            description: '请重新登录！'
          })
        }
        store.dispatch('Logout').then(() => {
          setTimeout(() => {
            if (!sysInfo.ifDebug) {
              location.href = sysInfo.loginURl
            } else {
              window.location.reload()
            }
          }, 1500)
        })
      } else if (error.response.status === 404) {
        console.log('404', error.response)
        // notification.error({
        //   message: '请求的资源不在',
        //   description: '请求的资源不在！'
        // })
        router.replace({ path: `${sysInfo.apiRemote}/404` })
      } else {
        if (error.response.data.status === 5006) {
          console.log('重复操作')
        } else {
          notification.error({
            message: '操作异常',
            description: error.response.data.info.message ? error.response.data.info.message : '请稍后再试'
          })
        }
      }
    }
  }
  return Promise.reject(error)
}

service.interceptors.request.use(config => {
  let url = config.url
  // get参数编码
  if (config.method === 'get' && config.params) {
    url += '?'
    const keys = Object.keys(config.params)
    for (const key of keys) {
      url += `${key}=${encodeURIComponent(config.params[key])}&`
    }
    url = url.substring(0, url.length - 1)
    config.params = {}
  }
  config.url = url
  return config
}, err)

// request interceptor
service.interceptors.request.use(config => {
  const token = Vue.ls.get(ACCESS_TOKEN)
  if (token) {
    config.headers['Authorization'] = token // 让每个请求携带自定义 token 请根据实际情况自行修改
  }
  return config
}, err)

// response interceptor
service.interceptors.response.use((response) => {
  // console.log('response', response)
  if (response.data.status === 1009 && !sysInfo.ifDebug) {
    notification.error({
      message: '登录过期',
      description: '请重新登录！'
    })
    store.dispatch('Logout').then(() => {
      setTimeout(() => {
        location.href = sysInfo.loginURl
      }, 1500)
    })
  }
  return response.data
}, err)

const installer = {
  vm: {},
  install (Vue) {
    Vue.use(VueAxios, service)
  }
}

export {
  installer as VueAxios,
  service as axios
}
